module.exports = {"about":"acerca"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/localized-urls/es.json
// module id = hy/V
// module chunks = 1